module.exports = {"110112001":"中仓街道","110112002":"新华街道","110112003":"北苑街道","110112004":"玉桥街道","110112005":"永顺地区","110112006":"梨园地区","110112104":"宋庄镇","110112105":"张家湾镇","110112106":"漷县镇","110112109":"马驹桥镇","110112110":"西集镇","110112114":"台湖镇","110112117":"永乐店镇","110112119":"潞城镇","110112209":"于家务回族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/110112.json
// module id = 30
// module chunks = 0